import React from "react";
import PlatformConnection from "@/components/connections/PlatformConnection";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import Container from "../Container";
import Page from "../Page";

const ConnectionsPage: React.FunctionComponent = () => {
  return (
    <Page>
      <Container>
        <div className="mb-6">
          <Heading level={1} variant="lg">Connections</Heading>
          <Text variant="sm" className="text-muted-foreground">
            Manage your integrations with external services
          </Text>
        </div>

        <div className="space-y-6">
          <div className="space-y-3">
            <Heading level={2} variant="sm">Support Platform</Heading>
            <Text variant="sm" className="text-muted-foreground">
              Connect your customer support platform to sync conversations and agent interactions.
            </Text>
            <PlatformConnection platform="intercom" />
          </div>

          <div className="space-y-3">
            <Heading level={2} variant="sm">Team Communication</Heading>
            <Text variant="sm" className="text-muted-foreground">
              Connect your team chat platform for notifications and real-time updates.
            </Text>
            <PlatformConnection platform="slack" />
          </div>
        </div>
      </Container>
    </Page>
  );
};

export default ConnectionsPage;
